import React from 'react';
import './AppNameLabel.scss';
import { getStateName } from '../../../../middleware/AngularExportedMiddleware';

const AppNameLabel = () => <div className="app-name-label-component">{getStateName()}</div>;

export default AppNameLabel;
